import React from 'react';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';

const ChooseEatings = ({ eatings, chosenEatings, toggleEating }) => {
  return (
    <React.Fragment>
      <H3>Выберите приемы пищи:</H3>
      <EatingsBlock itemsCenter={!eatings || !eatings.length}>
        {!eatings ||
          (!eatings.length && (
            <Loader type="Ball-Triangle" color="#3a3a3a" height="60" width="60" />
          ))}
        {eatings.map((eatingType) => (
          <Label
            key={eatingType.tag_id}
            htmlFor={`eating_${eatingType.tag_id}`}
            onClick={() => toggleEating(eatingType.tag_id)}
          >
            <EatingCheckbox
              type="checkbox"
              checked={chosenEatings.includes(eatingType.tag_id)}
              value={eatingType.tag_id}
              onChange={() => {}} // for removing warning
            />
            {eatingType.name}
          </Label>
        ))}
      </EatingsBlock>
    </React.Fragment>
  );
};
export default ChooseEatings;

const H3 = styled.h3`
  text-align: center;
  font-size: 20px;
  margin: 10px 0px;
`;

const EatingsBlock = styled.div`
  padding: 10px 5px;
  border: 1px solid #c1c1c1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.itemsCenter ? 'center' : 'flex-start')};
`;

const EatingCheckbox = styled.input`
  margin-right: 5px;
`;

const Label = styled.label`
  cursor: pointer;
  font-size: 18px;
  margin: 5px;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/ChooseEatings.jsx